<template>
  <v-layout>
    <v-card v-if="!emailSent" class="w-100 elevation-1 pa-3">
      <v-form @submit.prevent="resetPassword">
        <v-card-text>
          <v-alert
            v-if="formError"
            type="error">
            {{formError}}
          </v-alert>
          <v-text-field
            label="Телефон"
            type="tel"
            v-model="user.phone"
            :disabled="loading"
            required
          ></v-text-field>
          <v-text-field
            label="Имеил"
            type="email"
            v-model="user.email"
            :disabled="loading"
            required
          ></v-text-field>

        </v-card-text>
        <v-card-text style="display: flex; padding-top: 0;">
          <router-link :to="{ name: 'login.index'}">
            На страницу входа?
          </router-link>
          <v-spacer></v-spacer>
          <v-btn type="submit" color="primary" :loading="loading"
          >
            {{lang($store, 'sap/buttons.reset_password')}}
          </v-btn>
        </v-card-text>
      </v-form>
    </v-card>
    <v-alert
      v-else
      border="top"
      colored-border
      type="info"
      elevation="2"
    >
      {{emailSent}}
      <div>
        <router-link :to="{ name: 'login.index'}">
          {{lang($store, 'sap/login.labels.back_to_login')}}
        </router-link>
      </div>
    </v-alert>
  </v-layout>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'LoginForgotPassword',
  components: {},
  data() {
    return {
      emailSent: false,
      loading: false,
      user: {
        phone: '',
        email: '',
      },
      error: null,
      errors: [],
    };
  },
  computed: {
    formError() {
      if (!_.isEmpty(this.errors)) {
        const errors = this.errors[Object.keys(this.errors)[0]];
        return errors[0];
      }
      if (!_.isEmpty(this.error)) {
        return this.error;
      }

      return null;
    },
  },
  methods: {
    // TODO: create mixin for form errors
    resetPassword() {
      this.loading = true;
      this.$store.dispatch('auth/resetPassword', this.user)
        .then((response) => {
          this.emailSent = response.data.message;
        })
        .catch((response) => {
          if (response) {
            this.errors = [];
            this.error = null;
            switch (response.status) {
              case 422:
                if (_.isEmpty(response.data.data)) {
                  this.error = response.data.message;
                  this.$store.dispatch('page/displaySnackbar', {
                    text: this.error,
                    color: 'red darken-3',
                    timeout: 6000,
                  });
                }
                this.errors = response.data.data;
                break;
              default:
                // eslint-disable-next-line no-case-declarations
                let message = response.statusText;
                if (response.data.message) {
                  // eslint-disable-next-line prefer-destructuring
                  message = response.data.message;
                }
                this.$store.dispatch('page/displaySnackbar', {
                  text: message,
                  color: 'red darken-3',
                  timeout: 6000,
                });
                console.error(response);
                break;
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
